export default [
    {
        path: '/rebalancing/index',
        name: 'rebalancing/index',
        meta: {
            title: "调仓扫码"
        },
        component: () => import('@/views/rebalancing/index')
    },
    {
        path: '/rebalancing/byOrder',
        name: 'rebalancing/byOrder',
        meta: {
            title: "按单调仓"
        },
        component: () => import('@/views/rebalancing/byOrder')
    }
    ,
    {
        path: '/rebalancing/byFast',
        name: 'rebalancing/byFast',
        meta: {
            title: "快速调仓"
        },
        component: () => import('@/views/rebalancing/byFast')
    }
    ,
    {
        path: '/rebalancing/order',
        name: 'rebalancing/order',
        meta: {
            title: "调仓单"
        },
        component: () => import('@/views/rebalancing/order')
    }
    ,
    {
        path: '/rebalancing/orderDetail',
        name: 'rebalancing/orderDetail',
        meta: {
            title: "调仓单详情"
        },
        component: () => import('@/views/rebalancing/orderDetail')
    }
]
